import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

// modules
import styles from '../Containers.module.scss';

class WhyUseRealtor extends PureComponent {
  render() {
    return (
      <Container fluid className={styles.WhyUseRealtor}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to="/about">
                <BreadcrumbItem active>
                  Why Use a REALTOR<sup>®</sup>?
                </BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <Container>
          <p>
            All real estate licensees are not the same. Only real estate licensees who are
            members of the NATIONAL ASSOCIATION OF REALTORS
            <sup>®</sup> are properly called REALTORS<sup>®</sup>. They proudly display
            the REALTOR "®" logo on their business cards or other marketing and sales
            literature. REALTORS
            <sup>®</sup> are committed to treat all parties to a transaction honestly.
            REALTORS<sup>®</sup> subscribe to a strict Code of Ethics and are expected to
            maintain a higher level of knowledge of the process of buying and selling real
            estate. An independent survey reports that 84% of home buyers would use the
            same REALTOR
            <sup>®</sup> again.
          </p>
          <p>
            Real estate transactions involve one of the biggest financial investments most
            people experience in their lifetime. Transactions today usually exceed
            $100,000. If you had a $100,000 income tax problem, would you attempt to deal
            with it without the help of a CPA? If you had a $100,000 legal question, would
            you deal with it without the help of an attorney? Considering the small upside
            cost and the large downside risk, it would be foolish to consider a deal in
            real estate without the professional assistance of a REALTOR
            <sup>®</sup>.
          </p>
          <p>
            But if you're still not convinced of the value of a REALTOR
            <sup>®</sup>, here are a dozen more reasons to use one:
          </p>
          <ol className={styles.list}>
            <li>
              <p>
                <strong>
                  Your REALTOR<sup>®</sup> can help you determine your buying power.
                </strong>{' '}
                Your buying power is determined by analyzing your financial reserves plus
                your borrowing capacity. If you give a REALTOR
                <sup>®</sup> some basic information about your available savings, income
                and current debt, he or she can refer you to lenders best qualified to
                help you. Most lenders – banks and mortgage companies – offer limited
                choices.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Your REALTOR<sup>®</sup> has many resources to assist you in your home
                  search.
                </strong>
                Sometimes the property you are seeking is available but not actively
                advertised in the market, and it will take some investigation by your
                agent to find all available properties.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Your REALTOR<sup>®</sup> can assist you in the selection process by
                  providing objective information about each property.
                </strong>{' '}
                Agents who are REALTORS<sup>®</sup> have access to a variety of
                informational resources. REALTORS<sup>®</sup> can provide local community
                information on utilities, zoning. schools, etc. There are two things
                you'll want to know: first, will the property provide the environment you
                want for a home or investment; and second, will the property have resale
                value when you are ready to sell?
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Your REALTOR<sup>®</sup> can help you negotiate.
                </strong>{' '}
                There are myriad negotiating factors – including but not limited to –
                price, financing, terms, date of possession and often the inclusion or
                exclusion of repairs, furnishings or equipment. The purchase agreement
                should provide a period of time for you to complete appropriate
                inspections and investigations of the property before you are bound to
                complete the purchase. Your agent can advise you as to which
                investigations and inspections are recommended or required.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Your REALTOR<sup>®</sup> can provide due diligence during the evaluation
                  of the property.
                </strong>{' '}
                Depending on the area and property, due diligence could include
                inspections for termites, dry rot, asbestos, faulty structure, roof
                condition, septic tank and well tests, just to name a few. Your REALTOR
                <sup>®</sup>
                can assist you in finding qualified responsible professionals to do most
                of these investigations and provide you with written reports. You will
                also want to see a preliminary report on the title of the property. Title
                indicates ownership of property and can be mired in confusing status of
                past owners or rights of access. The title to most properties will have
                some limitations; for example, easements (access rights) for utilities.
                Your REALTOR<sup>®</sup>, title company or attorney can help you resolve
                issues that might cause problems at a later date.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Your REALTOR<sup>®</sup> can help you understand different financing
                  options and identify qualified lenders.
                </strong>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Your REALTOR<sup>®</sup> can guide you through the closing process and
                  make sure everything flows together smoothly.
                </strong>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  When selling your home, your REALTOR<sup>®</sup> can give you up-to-date
                  information on what is happening in the marketplace and the price,
                  financing, terms and condition of competing properties.
                </strong>{' '}
                These are key factors in getting your property sold at the best price,
                quickly and with minimum hassle.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Your REALTOR<sup>®</sup> markets your property to other real estate
                  agents and the public.
                </strong>{' '}
                Often, your REALTOR<sup>®</sup> can recommend repairs or cosmetic work
                that will significantly enhance the salability of your property. Your
                REALTOR<sup>®</sup>
                markets your property to other real estate agents and the public. In many
                markets across the country, over 50% of real estate sales are cooperative
                sales; that is, a real estate agent other than yours brings in the buyer.
                Your REALTOR<sup>®</sup> acts as the marketing coordinator, disbursing
                information about your property to other real estate agents through a
                Multiple Listing Service or other cooperative marketing networks, open
                houses for agents, etc. The REALTOR<sup>®</sup> Code of Ethics requires
                REALTORS<sup>®</sup> to utilize these cooperative relationships when they
                benefit their clients.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Your REALTOR<sup>®</sup> will know when, where and how to advertise your
                  property.
                </strong>
                There is a misconception that advertising sells real estate. A NATIONAL
                ASSOCIATION OF REALTORS<sup>®</sup> study showed that 82% of real estate
                sales are the result of agent contacts through previous clients,
                referrals, friends, family and personal contacts. When a property is
                marketed with the help of your REALTOR<sup>®</sup>, you do not have to
                allow strangers into your home. Your REALTOR<sup>®</sup> will generally
                prescreen and accompany qualified prospects through your property.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Your REALTOR<sup>®</sup> can help you objectively evaluate every buyer's
                  proposal without compromising your marketing position.
                </strong>{' '}
                This initial agreement is only the beginning of a process of appraisals,
                inspections and financing – a lot of possible pitfalls. Your REALTOR
                <sup>®</sup> can help you write a legally binding, win-win agreement that
                will be more likely to make it through the process.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Your REALTOR<sup>®</sup> can help close the sale of your home.
                </strong>{' '}
                Between the initial sales agreement and closing (or settlement), questions
                may arise. For example, unexpected repairs are required to obtain
                financing or a cloud in the title is discovered. The required paperwork
                alone is overwhelming for most sellers. Your REALTOR<sup>®</sup> is the
                best person to objectively help you resolve these issues and move the
                transaction to closing (or settlement).
              </p>
            </li>
          </ol>
        </Container>
      </Container>
    );
  }
}

export default WhyUseRealtor;



// WEBPACK FOOTER //
// ./src/containers/WhyUseRealtor/WhyUseRealtor.js